export enum ProjectStatus {
  Public = 'public',
  Private = 'private',
  Archived = 'archived',
}
